import {get} from "lodash"
import BaseService from "./Base"
import {DeletePartnersPayload, EditPartnerPayload, ListPartnersPayload, PartnerCreatePayload} from "types/partners"

class PartnersService extends BaseService {
    getAllPartners = async (params: ListPartnersPayload) => {
        const response = await this.post("/v1/partners/list", params)
        return get(response, "data", [])
    }

    createPartner = async (params: PartnerCreatePayload) => {
        const response = await this.post("/v1/partners/create", params)
        return get(response, "data.data", {})
    }

    editPartner = async (id: number, params: EditPartnerPayload) => {
        const response = await this.post("/v1/partners/edit", {...params, id})
        return get(response, "data.data", {})
    }

    deletePartners = async (params: DeletePartnersPayload) => {
        const response = await this.post("/v1/partners/delete", params)
        return get(response, "data.data", {})
    }
}

export default PartnersService
